import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Popper,
    Paper,
    IconButton,
    ClickAwayListener,
    Grow,
    MenuItem,
    MenuList
} from "@material-ui/core";

import {ReactComponent as MoreIcon} from "../../../common/images/MoreIcon.svg";
import {MobXProviderContext} from "mobx-react";
import {FormattedMessage} from "react-intl";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        "& .MuiPaper-root":{
            boxShadow:'0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border:'solid 0.5px #d4d4d6',
            borderRadius:7,
        },
        "& .MuiMenuItem-root":{
            paddingLeft:10,
            paddingRight:10
        }
    },
    moreIcon:{
        padding:8,
        "&:hover":{
            background:'#ededed'
        }
    },
    listText:{
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1rem',
        color: '#000',
    }
}));

export default function NoticeMoreButton(props) {
    const { userLoungeStore } = React.useContext(MobXProviderContext);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        userLoungeStore.changeIsSelectedNoticeModify(false);
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const handleModifyButton = () => {
        userLoungeStore.changeIsSelectedNoticeModify(true);
        setOpen(false);
    }

    const handleRemoveButton = () => {
        userLoungeStore.removeTeamNotice();
        props.contentClose();
        setOpen(false);
    }

    const handleSaveButton = () => {
        userLoungeStore.modifyTeamNotice();
        props.contentClose();
        setOpen(false);
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        prevOpen.current = open;
    }, [open]);

    return (
        <div className={classes.root}>
            <div>
                <IconButton
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    className={classes.moreIcon}
                >
                    <MoreIcon />
                </IconButton>
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    {
                                        userLoungeStore.isSelectedNoticeModify ?
                                            <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                <MenuItem className={classes.listText} onClick={handleSaveButton}><FormattedMessage id="save"/></MenuItem>
                                                <MenuItem className={classes.listText} onClick={handleClose}><FormattedMessage id="cancel"/></MenuItem>
                                            </MenuList>
                                            :
                                            <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                <MenuItem className={classes.listText} onClick={handleModifyButton}><FormattedMessage id="modify"/></MenuItem>
                                                <MenuItem className={classes.listText} onClick={handleRemoveButton}><FormattedMessage id="delete"/></MenuItem>
                                            </MenuList>
                                    }
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </div>
    );
};